exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-center, .text-center h5 {\n  text-align:center!important\n}\n.no-data-img {\n  display: inline\n}\n", ""]);

// exports
